import RootImpl from './Root.impl';
import { AxiosInstance } from 'axios';

export default class BaseElectronImplementation {
    root: RootImpl;
    constructor(root: RootImpl) {
        this.root = root;
    }
};